export type AddOn = ICfarAddOn | IChfarAddOn | IDisruptionProtectionAddOn;

export enum AddOnEnum {
  DisruptionProtection,
  Cfar,
  Chfar,
}

interface IAddOn {
  onClick: () => void;
  isEnabled: boolean;
  type: AddOnEnum;
}

interface ICfarAddOn extends IAddOn {
  expiryDate: string;
  expiredTz: string;
  type: AddOnEnum.Cfar;
}
interface IChfarAddOn extends IAddOn {
  expiryDate: string;
  expiredTz: string;
  type: AddOnEnum.Chfar;
}

interface IDisruptionProtectionAddOn extends IAddOn {
  type: AddOnEnum.DisruptionProtection;
  productVariant?: string;
}
